import { Route, Routes, Navigate } from "react-router-dom";
// App Routes
import appRoutes from "./app/app_routes";
import AuthProvider from "./auth_provider";
import PrivateRoute from "./private_router";

function App() {
  const configAppRoutes = appRoutes;

  const getAppRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.secure === true) {
        return (
          <Route element={<PrivateRoute />}>
            <Route
              exact
              path={route.route}
              element={route.component}
              key={route.key}
              title={route.name}
            />
          </Route>
        );
      }
      return (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.key}
          title={route.name}
        />
      );
    });

  return (
    <div>
      <AuthProvider>
        <Routes>
          {getAppRoutes(configAppRoutes)}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
